let currentToken = null;
let currentRefreshToken = null;

export const setTokenHelper = (token) => {
  currentToken = token;
  localStorage.setItem('token', token);
};

export const setRefreshTokenHelper = (refreshToken) => {
  currentRefreshToken = refreshToken;
  localStorage.setItem('refreshToken', refreshToken);
};

export const clearTokenHelper = () => {
  currentToken = null;
  currentRefreshToken = null;
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
};

export const getToken = () => currentToken || localStorage.getItem('token');

export const getRefreshToken = () => currentRefreshToken || localStorage.getItem('refreshToken');
